module.exports = __webpack_public_path__ + "static/media/4081313-uhd_3840_2160_24fps.26b4ef57.mp4";